import React from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import SellSecclAssetOptionsModalContent from './SellSecclAssetOptionsModalContent';
import { isWeb } from '../../../constants';
const SellSecclAssetOptionsModal = {
    show: (assetId) => {
        Modal.show(<SellSecclAssetOptionsModalContent assetId={assetId}/>, {
            containerStyle: styles.modal,
            title: 'Why are you selling?',
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
        // On web, inset the options so their hover highlight sits inside the modal
        ...(isWeb && { paddingHorizontal: 8, paddingBottom: 8 }),
    },
});
export default SellSecclAssetOptionsModal;
